export const doctorVerificationActions = {
  EMAIL: {
    REQUEST: 'verification-email/verification-email-request',
    SUCCESS: 'verification-email/verification-email-success',
    FAILURE: 'verification-email/verification-email-failure'
  },

  PHONE: {
    REQUEST: 'verification-phone/verification-phone-request',
    SUCCESS: 'verification-phone/verification-phone-success',
    FAILURE: 'verification-phone/verification-phone-failure'
  }
};

export const doctorResendVerificationActions = {
  RESEND_VERIFICATION_EMAIL: {
    REQUEST: 'resend-verification-email/resend-verification-email-request',
    SUCCESS: 'resend-verification-email/resend-verification-email-success',
    FAILURE: 'resend-verification-email/resend-verification-email-failure'
  }
};
